import { AlertFanApiFactory } from "@energy-advice/alertfan-api-client";
import { easasAxios } from "services/HttpService";

export const AlertFanApi = AlertFanApiFactory(easasAxios, "alertfan");
